// extracted by mini-css-extract-plugin
export default {"Post":"Post_Post__xH3by","PostTitle":"Post_PostTitle__vy9R0","PostFooter":"Post_PostFooter__3pBti","PostContent":"Post_PostContent__jwozU","readMore":"Post_readMore__kNgxt"};